<div class="composer">
  <div class="composer-wrap">
    <div class="composer-tabs">
      <button [class.on]="activeTab === 'email'" (click)="selectTab('email')">✉ Email</button>
      <button [class.on]="activeTab === 'sms'" (click)="selectTab('sms')">💬 SMS</button>
      <button [class.on]="activeTab === 'note'" (click)="selectTab('note')">📝 Note</button>
    </div>
    <ng-container *ngIf="activeTab === 'email'">
      <div class="composer-row" *ngIf="toEmail">
        <span style="font-size:12px;color:#6b7280;">To: {{ toEmail }}</span>
      </div>
      <div class="composer-row">
        <select [(ngModel)]="templateId" (ngModelChange)="applyTemplate($event)">
          <option [ngValue]="null">Pick template…</option>
          <option *ngFor="let tpl of templates" [ngValue]="tpl.templateId">{{ tpl.name }}</option>
        </select>
        <input [(ngModel)]="subject" placeholder="Subject…" style="flex:1;">
      </div>
    </ng-container>
    <ng-container *ngIf="activeTab === 'sms'">
      <div class="composer-row">
        <span *ngIf="!hasMobile" style="font-size:12px;color:#e04e4e;padding:6px 0;">No mobile number on file</span>
        <span *ngIf="hasMobile" style="font-size:12px;color:#6b7280;padding:6px 0;">
          {{ charCount }} chars · {{ segmentCount }} segment{{ segmentCount !== 1 ? 's' : '' }}
        </span>
      </div>
    </ng-container>
    <ng-container *ngIf="activeTab === 'note'">
      <div class="composer-row">
        <span style="font-size:12px;color:#8a7a20;padding:6px 0;">Internal note — not visible to guest</span>
      </div>
    </ng-container>
    <textarea
      [(ngModel)]="body"
      (ngModelChange)="onBodyChange()"
      [placeholder]="activeTab === 'note' ? 'Add internal note…' : 'Write a reply…'">
    </textarea>
    <div class="composer-actions">
      <span class="attach">📎 Attach files · up to 10MB total</span>
      <button class="ai-suggest-btn" (click)="suggestReply()" [disabled]="suggesting || !conversationId" *ngIf="activeTab !== 'note'">
        {{ suggesting ? 'Thinking…' : 'Suggest Reply' }}
      </button>
      <span *ngIf="suggestError" class="ai-suggest-error">{{ suggestError }}</span>
      <button class="send" (click)="send()" [disabled]="sending || (activeTab === 'sms' && !hasMobile)">{{ sending ? 'Sending…' : 'Send →' }}</button>
    </div>
    <div *ngIf="sendError" style="color:#e04e4e;font-size:12px;margin-top:4px;">{{ sendError }}</div>
  </div>
</div>
